var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('h2',{attrs:{"align":"center"}},[_vm._v("注册")])])
}]

export { render, staticRenderFns }